import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-xblr-elements',
  templateUrl: './xblr-elements.component.html'
})
export class XBLRElementsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
